"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const FractureLine_1 = __importDefault(require("../../../molecules/FractureLine"));
const FractureOptions_1 = __importDefault(require("../../../molecules/FractureOptions"));
const ToolsMode_1 = __importDefault(require("../../../templates/ToolsMode"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const react_1 = require("react");
const useFractureOptions_1 = require("../../../hooks/useFractureOptions");
const animation_1 = require("../../../utils/animation");
function ToolFractureModePage() {
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const size = (0, ui_1.useScreenSize)();
    const theme = (0, styled_components_1.useTheme)();
    const bridge = (0, bridge_1.useBridge)();
    const { size: currentFractureSize } = (0, useFractureOptions_1.useFractureOptions)();
    const [fractureSize, setFractureSize] = (0, react_1.useState)(currentFractureSize);
    (0, react_1.useEffect)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.FractureSimple,
            currentOptions: { type: bridge_schema_1.ToolType.FractureSimple, sizeIndex: 3 },
            senderID: 'tool-fracture',
        });
    }, [bridge]);
    return ((0, jsx_runtime_1.jsxs)(ToolsMode_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.tools.fracture.title), clearTitle: (0, i18n_1.Localized)(i18n_1.Strings.tools.fracture.clear), onToggleUI: toggleUIHidden, "data-e2e": 'ToolFractureModePage_ToolsModeTemplate', children: [(0, jsx_runtime_1.jsx)(FractureLine_1.default, { width: size.width, height: size.height, color: theme.white_90, size: fractureSize, "data-e2e": 'ToolFractureModePage_ToolsFractureLine' }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolFractureModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsFractureOptionsPanel, { size: fractureSize, onSizeChange: setFractureSize, "data-e2e": 'ToolFractureModePage_StyledToolsFractureOptionsPanel' }) })] }));
}
exports.default = ToolFractureModePage;
const StyledToolsFractureOptionsPanel = (0, styled_components_1.default)(FractureOptions_1.default) `
  position: absolute;
  bottom: 20px;
  left: calc(50% - 25px);

  ${(0, animation_1.SlideDown)('130%')}
`;
